export default "__VITE_ASSET__BWQyHaFa__"